import { Component, DoCheck, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ThemeConfig } from 'src/app/app-config';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { TfService } from 'src/app/tf/tf-service.service';
import { TranslateService } from '@ngx-translate/core';
import { MatAccordion } from '@angular/material/expansion'
import { BehaviorSubject, Subscription, Observable, Subject, of, forkJoin } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, takeUntil, catchError } from 'rxjs/operators';
import { BasketService } from 'src/app/customer/cp-customer/cp-shopping-basket/service/shopping-basket.service';
import { LanguageService } from 'src/app/multi-language/language.service';
import { NotificationService } from '../../notification.service';
import { UnifiedSearchService, SearchResult } from 'src/app/Theme/layout/admin/nav-bar/nav-right/service/unified-search.service';
import { SpinnerService } from 'src/app/Theme/shared/service/spinner.service';
import { CustomToastService } from 'src/app/Theme/shared/service/toast.service';
import { ProductSpecificationFilterSidebarService } from 'src/app/customer/cf-customer/cf-product/product-specification-filter-sidebar/product-specification-filter-sidebar.service';
@Component({
  selector: 'app-nav-right',
  templateUrl: './nav-right.component.html',
  styleUrls: ['./nav-right.component.scss'],
  providers: [NgbDropdownConfig],
  animations: [
    trigger('slideInOutLeft', [
      transition(':enter', [style({ transform: 'translateX(100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(100%)' }))])
    ]),
    trigger('slideInOutRight', [
      transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('300ms ease-in', style({ transform: 'translateX(0%)' }))]),
      transition(':leave', [animate('300ms ease-in', style({ transform: 'translateX(-100%)' }))])
    ])
  ]
})
export class NavRightComponent implements OnInit, DoCheck, OnDestroy {
  @ViewChild('notificationDropdown') notificationDropdown!: ElementRef;
  @ViewChild('notificationBtn') notificationBtn!: ElementRef;
  @ViewChild(MatAccordion) accordion: MatAccordion;

  @ViewChild('searchContainer') searchContainer!: ElementRef;
  @ViewChild('searchInput') searchInput!: ElementRef;
  @ViewChild('searchDropdownList') searchDropdownList?: ElementRef<HTMLElement>;

  /** Mobile header: opens the left navigation sidebar (pcoded-navbar). */
  @Output() openSidebar = new EventEmitter<void>();

  /**
   * Figma mobile header (≤430px): hamburger | pill Search | cart | bell | avatar.
   * Hides language, filter chip, and profile chevron so the bar matches the design.
   */
  isMobileHeader = false;

  // Search-related properties
  searchQuery: string = '';
  optionHidden: boolean = false;
  selectedIndex: number | null = null;
  searchResponse: any = null; // Store the grouped response directly
  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();
  isSearchFocused: boolean = false;
  /** Mobile search dropdown scroll hints (Figma: chevron-down / chevron-up). */
  showSearchScrollDown = false;
  showSearchScrollUp = false;

  // Control flags
  isCustomer: boolean = false;
  isAdmin: boolean = false;
  userGroups: string[] = [];

  // Other properties
  isNotificationDropdownOpen = false;
  profilePicture = 'assets/images/user/avatar-1.jpg';
  user: any;
  visibleUserList: boolean;
  chatMessage: boolean;
  friendId: boolean;
  config: any;
  themeConfig: any;
  languageList;
  cartContent;
  totalItem = 0;
  cartItemCount = 0;
  storedCart: any;
  isStaf;
  token: string
  group;
  pictureUrl: any;
  isToggled: boolean;
  username: any;
  @Input() searchBar: boolean = true;
  isDropdownOpen = false;
  isDropdownOpenLang = false;

  // Notification properties
  notifications: any[] = [];
  listNotifications: any;
  AllNotifications: any;
  /** Popup list from GET /AD/notifications/ (all items; unread first, then newest). */
  popupUnreadList: any[] = [];
  /** When true, popup stays empty after "Mark all as read" until refetch completes. */
  private justMarkedAllAsRead = false;

  /** Product spec filter: enabled on routes that host the filter; elsewhere the control is hidden on /admin or shown disabled on customer routes. */
  showSpecFilterButton = false;
  /** When false, the spec filter button is not rendered (back-office `/admin` when the filter is inactive). */
  showSpecFilterControl = true;
  /** Mirrors {@link ProductSpecificationFilterSidebarService} for pressed/active styling. */
  specFilterOpen = false;
  unreadCount = 0;
  /** Unread notification count from BehaviorSubject (for bell icon badge). */
  notificationUnreadCount = 0;
  categorizedNotifications: any = {
    email: [],
    invoices: [],
    orders: [],
    discounts: [],
    actuality: [],
    joinUs: []
  };

  item: any;
  count: number = 0;
  isExpanded = false;
  isOpen = false;
  selectedNavItem: any = null;
  selectedNotification: any = null;
  notificationTypes = [];
  selectedType: any = "All";
  unreadCounts: { [type: string]: number } = {};
  itemCountSubscription: Subscription;
  selectedLanguage = 'en';
  private languageUpdateHandler = () => this.getCFLanguage();

  constructor(
    config: NgbDropdownConfig,
    private tfService: TfService,
    private router: Router,
    public translate: TranslateService,
    public languageService: LanguageService,
    private basketService: BasketService,
    public notificationService: NotificationService,
    private unifiedSearchService: UnifiedSearchService,
    private spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private toastService: CustomToastService,
    private specFilterSidebar: ProductSpecificationFilterSidebarService
  ) {
    config.placement = 'bottom-right';
    this.visibleUserList = false;
    this.chatMessage = false;
    this.config = ThemeConfig;
    this.username = JSON.parse(localStorage.getItem('user')).username || '';
    this.refreshDisplayGroup();

    // Keep the header selector aligned with LanguageService (same source as the sidebar).
    this.selectedLanguage = this.languageService.getCurrentLanguage();
    this.getCFLanguage();
  }

  ngOnInit(): void {
    this.updateMobileHeader();

    // Initialize search subject with debouncing
    this.initializeSearchSubject();

    // Load essential data only
    this.getUserAuthInfo();

    // Load basket and notification data (always needed)
    this.itemCountSubscription = this.basketService.itemCount$.subscribe(count => {
      this.cartItemCount = count;
    });

    this.loadPopupNotifications();

    this.notificationService.getUnreadCount()
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.notificationUnreadCount = count;
        this.cdr.detectChanges();
      });

    // Refresh notification list when requested (e.g. after reopen basket)
    this.notificationService.getRefreshRequested()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadPopupNotifications());

    // Load user profile data
    this.tfService.pictureUrl$.subscribe(url => {
      this.pictureUrl = url;
    });

    this.user = this.tfService.getUserFromLocalCache();
    this.fetchUserProfileData(this.user);

    // Listen for language list updates
    window.addEventListener('languageListUpdated', this.languageUpdateHandler);

    this.languageService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang) => {
        this.selectedLanguage = this.languageService.normalizeLanguageCode(lang) || 'en';
        this.cdr.detectChanges();
      });

    this.updateSpecFilterButtonVisibility(this.router.url);
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((e) => this.updateSpecFilterButtonVisibility(e.urlAfterRedirects));

    this.specFilterSidebar.isOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe((open) => {
        this.specFilterOpen = open;
        this.cdr.markForCheck();
      });
  }

  /** Routes where the spec filter shell is rendered (toggle lives here, not on the page body). */
  private updateSpecFilterButtonVisibility(url: string): void {
    const path = url.split('?')[0];
    this.showSpecFilterButton =
      path.includes('/customer/CFProduct/product-view') || path.includes('/sub-category/');
    const onAdminShell = path === '/admin' || path.startsWith('/admin/');
    this.showSpecFilterControl = this.showSpecFilterButton || !onAdminShell;
  }

  toggleSpecFilter(): void {
    if (!this.showSpecFilterButton) {
      return;
    }
    this.specFilterSidebar.toggleFilterBar();
  }

  /**
   * Initialize search subject with debouncing
   */
  private initializeSearchSubject(): void {
    this.searchSubject.pipe(
      debounceTime(300), // Wait 300ms after user stops typing
      distinctUntilChanged(), // Only emit if query actually changed
      takeUntil(this.destroy$)
    ).subscribe(query => {
      this.performActualSearch(query);
    });
  }

  /**
   * Enhanced search function with debouncing that properly handles search queries during data loading
   */
  performSearch(): void {
    this.optionHidden = false;
    const query = this.searchQuery.trim();

    if (query.length === 0) {
      this.searchResponse = null;
      this.selectedIndex = null;
      return;
    }

    // Use the search subject for debouncing
    this.searchSubject.next(query);
  }

  /**
   * Handle search input focus
   */
  onSearchFocus(): void {
    this.isSearchFocused = true;
    this.optionHidden = false;
    this.scheduleSearchScrollHintsUpdate();
  }

  onSearchDropdownScroll(): void {
    this.updateSearchScrollHints();
  }

  /**
   * Handle search input blur with a delay to allow for dropdown clicks
   */
  onSearchBlur(): void {
    // Add a small delay to allow for dropdown item clicks
    setTimeout(() => {
      this.isSearchFocused = false;
      // Only hide if no interaction happened
      if (!this.isSearchFocused) {
        this.optionHidden = true;
      }
    }, 200);
  }

  /**
   * Get all results as a flat array for navigation purposes
   */
  private getAllResults(): any[] {
    if (!this.searchResponse) return [];

    const allResults: any[] = [];

    // Add products
    if (this.searchResponse.product) {
      this.searchResponse.product.forEach(product => {
        allResults.push({ type: 'product', id: product.item, data: product });
      });
    }

    // Add sales orders
    if (this.searchResponse.salesOrder) {
      this.searchResponse.salesOrder.forEach(order => {
        allResults.push({ type: 'salesOrder', id: order.salesOrderPortalID || order.salesOrderLN, data: order });
      });
    }

    // Add business partners
    if (this.searchResponse.businessPartner) {
      this.searchResponse.businessPartner.forEach(partner => {
        allResults.push({ type: 'businessPartner', id: partner.portalContactID || partner.customer, data: partner });
      });
    }

    // Add contacts
    if (this.searchResponse.contact) {
      this.searchResponse.contact.forEach(contact => {
        allResults.push({ type: 'contact', id: contact.contact || contact.phoneNumber, data: contact });
      });
    }

    // Add customer orders
    if (this.searchResponse.salesOrderCustomer) {
      this.searchResponse.salesOrderCustomer.forEach(order => {
        allResults.push({ type: 'salesOrderCustomer', id: order.salesOrder, data: order });
      });
    }

    // Add invoices
    if (this.searchResponse.invoice) {
      this.searchResponse.invoice.forEach(invoice => {
        allResults.push({ type: 'invoice', id: invoice.invoiceId || invoice.orderId || invoice.status, data: invoice });
      });
    }

    // Add shipments
    if (this.searchResponse.shipment) {
      this.searchResponse.shipment.forEach(shipment => {
        allResults.push({ type: 'shipment', id: shipment.ShipmentID || shipment.InvoiceNumber || shipment.Status, data: shipment });
      });
    }

    return allResults;
  }

  /**
   * Handle keyboard navigation in search
   */
  onKeyDown(event: KeyboardEvent): void {
    const allResults = this.getAllResults();
    if (!allResults.length) return;

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.selectedIndex = this.selectedIndex === null ? 0 :
          Math.min(this.selectedIndex + 1, allResults.length - 1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.selectedIndex = this.selectedIndex === null ? allResults.length - 1 :
          Math.max(this.selectedIndex - 1, 0);
        break;
      case 'Enter':
        event.preventDefault();
        if (this.selectedIndex !== null && allResults[this.selectedIndex]) {
          this.navigateToResult(allResults[this.selectedIndex]);
        }
        break;
      case 'Escape':
        event.preventDefault();
        this.clearSearch();
        if (this.searchInput?.nativeElement) {
          this.searchInput.nativeElement.blur();
        }
        break;
    }
  }

  /**
   * Clear search functionality
   */
  clearSearch(): void {
    this.searchQuery = '';
    this.searchResponse = null;
    this.selectedIndex = null;
    this.optionHidden = true;
    this.isSearchFocused = false;
    this.showSearchScrollDown = false;
    this.showSearchScrollUp = false;
  }

  /**
   * Handle mouse enter on dropdown items
   */
  onDropdownItemMouseEnter(index: number): void {
    this.selectedIndex = index;
  }

  /**
   * Perform the actual search using unified search API
   */
  private performActualSearch(query: string): void {
    if (query.length < 2) {
      this.searchResponse = null;
      return;
    }

    this.spinnerService.show();

    const userRole = this.isAdmin ? 'admin' : this.isCustomer ? 'customer' : 'admin';

    this.unifiedSearchService.search(query).pipe(
      catchError(error => {
        console.error('Error performing search:', error);
        this.spinnerService.hide();
        return of({ product: [], salesOrder: [], businessPartner: [], contact: [], salesOrderCustomer: [], invoice: [], shipment: [] });
      })
    ).subscribe(response => {
      // Store the grouped response directly - no transformation needed!
      this.searchResponse = response;
      this.spinnerService.hide();
      console.log('Search results:', this.searchResponse);
      this.scheduleSearchScrollHintsUpdate();
    });
  }

  private isMobileSearchDropdown(): boolean {
    return typeof window !== 'undefined' && window.innerWidth <= 430;
  }

  private scheduleSearchScrollHintsUpdate(): void {
    if (!this.isMobileSearchDropdown()) {
      this.showSearchScrollDown = false;
      this.showSearchScrollUp = false;
      return;
    }

    setTimeout(() => {
      const list = this.searchDropdownList?.nativeElement;
      if (list) {
        list.scrollTop = 0;
      }
      this.updateSearchScrollHints();
    }, 0);
  }

  private updateSearchScrollHints(): void {
    if (!this.isMobileSearchDropdown()) {
      this.showSearchScrollDown = false;
      this.showSearchScrollUp = false;
      return;
    }

    const list = this.searchDropdownList?.nativeElement;
    if (!list) {
      this.showSearchScrollDown = false;
      this.showSearchScrollUp = false;
      return;
    }

    const threshold = 2;
    const { scrollTop, scrollHeight, clientHeight } = list;
    const canScroll = scrollHeight - clientHeight > threshold;
    const atBottom = scrollTop + clientHeight >= scrollHeight - threshold;

    this.showSearchScrollDown = canScroll && !atBottom;
    this.showSearchScrollUp = canScroll && atBottom;
  }

  getUserAuthInfo() {
    this.tfService.checkAuthStatus().subscribe((authData: any) => {
      this.userGroups = authData.userGroups || [];
      this.isCustomer = this.tfService.isCustomerPortalUser(this.userGroups);
      this.isAdmin = authData.isSuperuser || authData.isStaff || this.userGroups.includes('admin');

      console.log('User role determined:', {
        isCustomer: this.isCustomer,
        isAdmin: this.isAdmin,
        userGroups: this.userGroups
      });

      this.refreshDisplayGroup();
    });
  }

  /** Profile subtitle: first user group from storage, without JSON brackets. */
  private refreshDisplayGroup(): void {
    const groups = this.tfService.getUserGroupsFromLocalStorage();
    this.group = groups.length ? groups.join(', ') : '';
  }

  navigateToResult(result: SearchResult): void {
    // Clear the search input and hide dropdown
    this.clearSearch();

    // Blur the search input to remove focus
    if (this.searchInput?.nativeElement) {
      this.searchInput.nativeElement.blur();
    }

    switch (result.type) {
      case 'product':
        this.navigateToProduct(result.id);
        break;

      case 'salesOrder':
        this.navigateToSalesOrder(result.data);
        break;

      case 'salesOrderCustomer':
        this.navigateToCustomerOrder(result.data);
        break;

      case 'businessPartner':
        this.router.navigate(['/admin/cp-bp-management/cp-customer/customer-list']);
        break;

      case 'contact':
        this.router.navigate(['/admin/cp-bp-management/contact-list']);
        break;

      case 'invoice':
        this.navigateToInvoice(result.data);
        break;

      case 'shipment':
        this.navigateToShipment(result.data);
        break;
    }
  }

  private navigateToProduct(productId: string): void {
    const currentUrl = this.router.url;
    const isOnProductPage = currentUrl.includes('/admin/cf-product/product-details/') ||
                           currentUrl.includes('/customer/CFDashboard/detail-product/');

    // Encode the product ID to handle special characters like "/"
    const encodedProductId = encodeURIComponent(productId);
    const targetRoute = this.isAdmin
      ? ['/admin/cf-product/product-details', encodedProductId]
      : ['/customer/CFDashboard/detail-product', encodedProductId];

    if (isOnProductPage) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(targetRoute);
      });
    } else {
      this.router.navigate(targetRoute);
    }
  }

  private navigateToSalesOrder(orderData: any): void {
    // Extract the sales order identifier
    const searchTerm = orderData.salesOrderLN || orderData.salesOrderPortalID || '';

    // Navigate to the sales order list page with search term
    this.router.navigate(['/admin/cp-sales-orders/sales-order-list'], {
      queryParams: { searchTerm: searchTerm }
    });
  }

  private navigateToCustomerOrder(orderData: any): void {
    this.router.navigate(['/customer/cp-order/orders'], {
      queryParams: { searchData: JSON.stringify(orderData) }
    });
  }

  private navigateToInvoice(invoiceData: any): void {
    this.router.navigate(['/customer/invoice/CpInvoiceList'], {
      queryParams: { searchData: JSON.stringify(invoiceData) }
    });
  }

  private navigateToShipment(shipmentData: any): void {
    this.router.navigate(['/customer/cp-shipment/shipments'], {
      queryParams: { searchData: JSON.stringify(shipmentData) }
    });
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    if (this.isMobileView()) {
      this.isDropdownOpen = false;
      this.router.navigateByUrl('/tf/navigationprofile');
      return;
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  private isMobileView(): boolean {
    return window.innerWidth <= 430;
  }

  toggleDropdownLanguage(event: Event) {
    event.stopPropagation();
    this.isDropdownOpenLang = !this.isDropdownOpenLang;
    // Refresh language list when opening dropdown to ensure we have latest data
    if (this.isDropdownOpenLang) {
      this.getCFLanguage();
    }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateMobileHeader();
  }

  private updateMobileHeader(): void {
    const next = typeof window !== 'undefined' && window.innerWidth <= 430;
    if (next !== this.isMobileHeader) {
      this.isMobileHeader = next;
    }
    this.updateSearchScrollHints();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: any) {
    // Profile dropdown handling (same behavior as language dropdown)
    const profileDropdownElement = event.target.closest('.profile-dropdown');
    const profileItemClicked = event.target.closest('.profile-item');

    if (this.isDropdownOpen && (!profileDropdownElement || profileItemClicked)) {
      this.isDropdownOpen = false;
    }

    // Language dropdown handling
    const langDropdownElement = event.target.closest('.language-dropdown');
    const langItemClicked = event.target.closest('.language-item');

    if (this.isDropdownOpenLang && (!langDropdownElement || langItemClicked)) {
      this.isDropdownOpenLang = false;
    }

    // Search dropdown handling
    const searchContainer = event.target.closest('.search-container');
    const dropdownItem = event.target.closest('.dropdown-item');

    if (!searchContainer || dropdownItem) {
      this.isSearchFocused = false;
      this.optionHidden = true;
    }

    // Notification dropdown handling - now handled by generic component
    // The generic component has its own click outside handler
  }

  toggleNotificationDropdown(event?: Event) {
    if (event) {
      event.stopPropagation(); // Prevent event from bubbling to document
    }
    const willOpen = !this.isNotificationDropdownOpen;
    this.isNotificationDropdownOpen = willOpen;
    if (willOpen) {
      this.loadPopupNotifications();
    }
  }

  closeNotificationDropdown() {
    this.isNotificationDropdownOpen = false;
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
    this.selectedType = "All";
  }

  selectNavItem(item: any) {
    this.selectedNavItem = item;
    this.selectedNotification = null;
  }

  openNotification(type: any) {
    this.selectedType = type;
    this.isOpen = !this.isOpen;
    this.listNotifications = this.AllNotifications.filter(
      n => n.notification_type === type
    );
  }

  openNotification2(type: any) {
    this.selectedType = type;
    this.listNotifications = this.AllNotifications.filter(
      n => n.notification_type === type
    );
  }

  markAllAsRead() {
    this.justMarkedAllAsRead = true;
    this.popupUnreadList = [];
    this.notificationService.setUnreadCount(0);
    this.cdr.detectChanges();
    this.notificationService.markAllAsRead().subscribe({
      next: () => {
        this.notificationService.markPendingNotificationsAsRead();
        this.loadPopupNotifications();
      },
      error: (err) => {
        this.justMarkedAllAsRead = false;
        console.error('Mark all as read failed:', err);
        this.cdr.detectChanges();
      }
    });
  }

  /** Unread = not explicitly read (handles read / is_read from backend). */
  private isUnread(n: any): boolean {
    if (!n) return true;
    const read = n.read ?? n.is_read;
    return read !== true && read !== 'true';
  }

  /**
   * Loads popup notifications from GET /AD/notifications/ (all notifications).
   * Sets popupUnreadList, listNotifications, AllNotifications, notificationTypes, unreadCounts, bell badge.
   */
  loadPopupNotifications() {
    this.notificationService.getNotif().subscribe({
      next: (res) => {
        const rawList = Array.isArray(res) ? res : (res && res.results) ? res.results : [];
        const httpMapped = rawList.map((n: any) => this.notificationService.normalizeForDisplay(n));
        const wsMapped = this.notificationService.getNotificationsSnapshot()
          .map((n: any) => this.notificationService.normalizeForDisplay(n));
        const merged = this.mergeNotificationLists(wsMapped, httpMapped);
        const sorted = this.sortNotificationsForPopup(merged);

        this.popupUnreadList = sorted;
        this.listNotifications = sorted;
        this.AllNotifications = sorted;
        this.justMarkedAllAsRead = false;
        this.recomputeUnreadAggregates();
        this.cdr.detectChanges();
      },
      error: () => {
        this.justMarkedAllAsRead = false;
        this.popupUnreadList = [];
        this.listNotifications = [];
        this.AllNotifications = [];
        this.notificationTypes = [];
        this.unreadCounts = {};
        this.notificationService.setUnreadCount(0);
        this.cdr.detectChanges();
      }
    });
  }

  /** Merge WebSocket + HTTP lists; WebSocket entries win when ids match. */
  private mergeNotificationLists(wsItems: any[], httpItems: any[]): any[] {
    const byKey = new Map<string, any>();
    const put = (item: any) => {
      const id = item?.id ?? item?.message?.id;
      const key = id != null ? `id:${id}` : `tmp:${item?.title}:${item?.message}:${item?.created_at}`;
      byKey.set(key, item);
    };
    httpItems.forEach(put);
    wsItems.forEach(put);
    return Array.from(byKey.values());
  }

  /** Unread first, then newest first (same as full notification list). */
  private sortNotificationsForPopup(items: any[]): any[] {
    return [...items].sort((a: any, b: any) => {
      const aRead = !!a?.read;
      const bRead = !!b?.read;
      if (aRead !== bRead) {
        return aRead ? 1 : -1;
      }
      const aTime = a?.created_at ? new Date(a.created_at).getTime() : 0;
      const bTime = b?.created_at ? new Date(b.created_at).getTime() : 0;
      return bTime - aTime;
    });
  }

  /** Bell badge + per-type unread counts from the current popup list. */
  private recomputeUnreadAggregates(): void {
    const list = this.popupUnreadList || [];
    const unreadTotal = list.filter((n: any) => this.isUnread(n)).length;
    this.notificationService.setUnreadCount(unreadTotal);
    this.notificationTypes = [
      ...new Set(list.map((n: any) => n.notification_type).filter(Boolean))
    ];
    this.unreadCounts = {};
    this.notificationTypes.forEach((type: string) => {
      this.unreadCounts[type] = list.filter(
        (n: any) => n.notification_type === type && this.isUnread(n)
      ).length;
    });
  }

  /** Full list (all notifications). Used by tf-notification-list; kept for openNotification/openNotification2 if needed. */
  getAllNotification() {
    this.notificationService.getNotif().subscribe({
      next: (res) => {
        const rawList = Array.isArray(res) ? res : (res && res.results) ? res.results : [];
        const mapped = rawList.map((n: any) => {
          const item = n.message
            ? { ...n.message, created_at: n.message.date || n.created_at }
            : { ...n, created_at: n.created_at || n.date };
          const rawRead = item.read ?? item.is_read;
          item.read = rawRead === true || rawRead === 'true';
          return item;
        });
        const sorted = [...mapped].sort((a: any, b: any) => {
          const aRead = !!a?.read;
          const bRead = !!b?.read;
          if (aRead !== bRead) return aRead ? 1 : -1;
          const aTime = a?.created_at ? new Date(a.created_at).getTime() : 0;
          const bTime = b?.created_at ? new Date(b.created_at).getTime() : 0;
          return bTime - aTime;
        });
        this.listNotifications = sorted;
        this.AllNotifications = sorted;
        this.notificationTypes = [
          ...new Set(this.listNotifications.map((n: any) => n.notification_type).filter(Boolean))
        ];
        this.unreadCounts = {};
        this.notificationTypes.forEach((type: string) => {
          this.unreadCounts[type] = this.listNotifications.filter(
            (n: any) => n.notification_type === type && this.isUnread(n)
          ).length;
        });
        this.cdr.detectChanges();
      },
      error: () => {
        this.listNotifications = [];
        this.AllNotifications = [];
        this.notificationTypes = [];
        this.unreadCounts = {};
        this.cdr.detectChanges();
      }
    });
  }

  fetchUserProfileData(user): void {
    this.tfService.profile(user.userId).subscribe(
      (data: any) => {
        this.pictureUrl = data.picture
      }
    );
  }

  /**
   * Returns the i18n key for the language name so it is translated in the current UI language
   * (e.g. when app is in French, "fr" shows as "Français" not "French").
   */
  getLanguageNameKey(code: string): string {
    if (!code) return '';
    const lower = code.toLowerCase();
    if (lower === 'en') return 'English';
    if (lower === 'fr') return 'French';
    if (lower === 'nl') return 'Dutch';
    return code;
  }

  changeSiteLanguage(langset: string): void {
    const normalized = this.languageService.normalizeLanguageCode(langset) || langset;
    this.selectedLanguage = normalized;
    this.languageService.setLanguage(normalized);
    this.isDropdownOpenLang = false;
  }

  isLanguageSelected(code: string): boolean {
    return this.languageService.normalizeLanguageCode(code) === this.selectedLanguage?.toLowerCase();
  }

  ngDoCheck() {
    if (document.querySelector('body').classList.contains('datta-rtl')) {
      this.config['rtl-layout'] = true;
    } else {
      this.config['rtl-layout'] = false;
    }
  }

  navigateAndCloseProfile(url: string): void {
    this.isDropdownOpen = false;
    this.router.navigateByUrl(url);
  }

  logout() {
    this.tfService.logout().subscribe({
      next: () => {
        this.router.navigateByUrl('/auth/signin');
      },
      error: (error) => {
        console.error('Logout failed', error);
      }
    });
  }

  public getCFLanguage() {
    this.languageService.searchLanguage("").subscribe((res) => {
      this.languageList = res;

      const currentLangCode = this.languageService.getCurrentLanguage();

      // Check if current selected language is still active
      const currentLangActive = res.find((lang: any) =>
        lang.code?.toLowerCase() === currentLangCode && lang.status === 'active'
      );

      // If current selected language is no longer active, switch to first active language
      if (!currentLangActive && res.length > 0) {
        const firstActiveLang = res.find((lang: any) => lang.status === 'active');
        if (firstActiveLang?.code) {
          this.changeSiteLanguage(firstActiveLang.code);
        }
      }
    });
  }

  /** Mark one item as read locally so it stays visible with read styling; updates badge counts. */
  private applyNotificationReadLocally(notification: any): void {
    notification.read = true;
    if (notification.message && typeof notification.message === 'object') {
      notification.message.read = true;
    }
    this.popupUnreadList = this.sortNotificationsForPopup(this.popupUnreadList || []);
    this.listNotifications = this.popupUnreadList;
    this.AllNotifications = this.popupUnreadList;
    this.recomputeUnreadAggregates();
    this.cdr.detectChanges();
  }

  /**
   * Mark a single notification as read (popup). Calls PUT /AD/mark_read/{pk}/, keeps item in list as read, toast.
   */
  onNotificationClick(notification: any) {
    const pk = notification?.id ?? notification?.message?.id;
    if (pk != null) {
      this.notificationService.markAsRead(pk).subscribe({
        next: () => {
          this.applyNotificationReadLocally(notification);
          const msg = this.translate.instant('TFNotification.MarkAsReadToast');
          this.toastService.showSuccess(msg, '');
        },
        error: () => {
          this.toastService.showError(
            this.translate.instant('TFNotification.MarkAsReadError'),
            ''
          );
        }
      });
    } else {
      this.applyNotificationReadLocally(notification);
      const msg = this.translate.instant('TFNotification.MarkAsReadToast');
      this.toastService.showSuccess(msg, '');
    }
  }

  onCheckNow(notification: any) {
    // Extract basket name from notification message
    const match = (notification.message || '').match(/"([^"]+)"/);
    const basketName = match ? match[1] : null;
    if (!basketName) {
      alert('No basket name found in notification.');
      return;
    }

    // Redirect to shopping basket with basket name as query parameter
    this.router.navigate(['/shopping-basket'], { queryParams: { activateBasket: basketName } });
  }

  getInitials(title: string): string {
    if (!title) return 'N';
    const words = title.trim().split(' ');
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return title[0].toUpperCase();
  }

  getAvatarClass(index: number): string {
    const classes = ['orange', 'slate', 'blue'];
    return classes[index % classes.length];
  }

  formatNotificationTime(date: string): string {
    if (!date) return '';
    try {
      const notificationDate = new Date(date);
      if (isNaN(notificationDate.getTime())) return '';
      
      const now = new Date();
      const diffInMs = now.getTime() - notificationDate.getTime();
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
      
      const timeStr = notificationDate.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit',
        hour12: true 
      });

      if (diffInDays === 0) {
        return `Today<br>at ${timeStr}`;
      } else if (diffInDays === 1) {
        return `Yesterday<br>at ${timeStr}`;
      } else if (diffInDays < 7) {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return `Last ${days[notificationDate.getDay()]}<br>at ${timeStr}`;
      } else {
        return notificationDate.toLocaleDateString('en-US', { 
          month: 'short', 
          day: 'numeric' 
        }) + `<br>at ${timeStr}`;
      }
    } catch (e) {
      return '';
    }
  }

  getUnreadCountForType(type: string): number {
    return this.unreadCounts[type] || 0;
  }

  isFirstOfType(notification: any, index: number): boolean {
    const list = this.popupUnreadList;
    if (!list.length || index === 0) return true;
    for (let i = 0; i < index; i++) {
      if (list[i].notification_type === notification.notification_type) return false;
    }
    return true;
  }

  getEmptyStateMessage(): string {
    const translated = this.translate.instant('TFNotification.NoNotifications');
    return translated !== 'TFNotification.NoNotifications' ? translated : 'No notifications';
  }

  ngOnDestroy(): void {
    // Complete all subscriptions
    this.destroy$.next();
    this.destroy$.complete();

    if (this.itemCountSubscription) {
      this.itemCountSubscription.unsubscribe();
    }

    // Remove event listener
    window.removeEventListener('languageListUpdated', this.languageUpdateHandler);
  }
}
